import React, { useRef } from 'react';
import { Chart, ChartData, ChartOptions } from 'chart.js';
import { FiltroSopFinance } from '../../core/repositories/sopFinanceRepositorio';
import { formatarDecimal, formatarPorcentagem } from '../../core/utils/funcoes';
import { Line } from 'react-chartjs-2';
import { useTranslation } from 'react-i18next';
import { useToast } from '../../core/contexts/toast';
import { RepositorioSopFinance } from '../../core/repositories/sopFinanceRepositorio';
import SopLoadingAnimation from '../../components/sopLoadingAnimation';


const SopFinanceMarginChart: React.FC<{ filtro: FiltroSopFinance, home:boolean }> = (props) => {

    const { mostrarToast } = useToast();
    const { t } = useTranslation();

    const chartRef = useRef<Chart<'line'>>(null);
    const [data, setData] = React.useState<ChartData<'line'>>({} as ChartData<'line'>);
    const [carregando, setCarregando] = React.useState(true);

    React.useEffect(() => {
        setCarregando(true);
        new RepositorioSopFinance().getKpis(props.filtro).then((res) => {
            const labels: string[] = [];
            const num_gross_margin_real: (number | null)[] = [];
            const num_gross_margin_forecast: (number | null)[] = [];
            const num_gross_margin_budget: (number | null)[] = [];

            // AVG(num_gross_margin_real) AS num_gross_margin_real,
            // AVG(num_gross_margin_forecast) AS num_gross_margin_forecast,
            // AVG(num_gross_margin_budget) AS num_gross_margin_budget


            res.forEach((item: any) => {
                labels.push(item.mes || "");
                num_gross_margin_real.push( item.num_gross_margin_real);
                num_gross_margin_forecast.push(item.num_gross_margin_forecast);
                num_gross_margin_budget.push(item.num_gross_margin_budget);
                
            });

            setData({
                labels: labels,
                datasets: [
                    {
                        label: 'Gross Margin Real',
                        data: num_gross_margin_real,
                        borderColor: '#90CAF9',
                        backgroundColor: '#90CAF9',
                    },
                    {
                        label: 'Gross Margin Forecast',
                        data: num_gross_margin_forecast,
                        borderColor: '#0089F8',
                        backgroundColor: '#0089F8',
                    },
                    {
                        label: 'Gross Margin Budget',
                        data: num_gross_margin_budget,
                        borderColor: '#FF9800',
                        backgroundColor: '#FF9800',
                    },
                   
                ],
            });
            setCarregando(false);
        }).catch((error) => {
            mostrarToast({
                titulo: t("pages.Erro!"),
                mensagem: t("pages.Aconteceu algo inesperado, por favor tente novamente mais tarde!"),
                tipo: "error",
            });
        })




    }, [props.filtro]);

    // const data: ChartData<"line"> = {
    //     labels: ['Dec/2024', 'Jan/2025', 'Feb/2025', 'Mar/2025', 'Apr/2025', 'May/2025', 'Jun/2025'],
    //     datasets: [

    //         {
    //             label: 'Forecast Accuracy',
    //             data: [75, 85, 94, 52, 62, 45, 48],
    //             borderColor: '#90CAF9',
    //             backgroundColor: '#90CAF9',
    //         },
    //         {
    //             label: 'YoY',
    //             data: [85, 74, 105, 96, 85, 74, 85],
    //             borderColor: '#0089F8',
    //             backgroundColor: '#0089F8',
    //         },

    //     ],
    // }

    const options: ChartOptions<"line"> = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
            },
            tooltip: {
                mode: 'index',
                intersect: false,
            },
            title: {
                display: false,
            },
        },
        interaction: {
            mode: 'nearest',
            axis: 'x',
            intersect: false,
        },
        scales: {
            x: {
            },
            y: {
                ticks: {
                    callback:
                        (value: any) => formatarPorcentagem(value/100)
                    // props.filtro?.value !== "Quantity"
                    //     ? (value: any) => formatarDecimal(value, true)
                    //     : (value: any) => formatarDecimal(value),
                },
                beginAtZero: false,
            },
        },
    }


    return (


        <div className="card p-3 shadow-sm border-0" style={{ height: '250px' }}>
            <strong className=" title-card">{props.home? "Finance": "KPI"}</strong>
            {carregando ?
                <SopLoadingAnimation type="LINE" />
                :
                <div>
                    <Line ref={chartRef} options={options} data={data} />
                </div>
            }
        </div>
    );
};

export default SopFinanceMarginChart;
